import * as paths from 'utils/paths'
import * as fromEntities from '@src/redux/modules/entities'

export default function redirectToConfirmationIfNotFirstService (store) {
  return (nextState, replace) => {
    const { userId, aliadaId } = nextState.params

    const state = store.getState()
    const user = fromEntities.getUsers(state)[userId]

    if (!user) {
      return
    }

    const confirmationScreenPath = paths.bookingConfirmation(aliadaId)
    const onWayToConfirmationScreen = nextState.location.pathname === confirmationScreenPath

    if (!onWayToConfirmationScreen && user.servicesCount > 0) {
      replace(confirmationScreenPath)
    }
  }
}



// WEBPACK FOOTER //
// ./src/routes/middleware/redirectToConfirmationIfNotFirstService.js